import { render, staticRenderFns } from "./ItemTest.vue?vue&type=template&id=168a9a54&scoped=true&"
import script from "./ItemTest.vue?vue&type=script&lang=js&"
export * from "./ItemTest.vue?vue&type=script&lang=js&"
import style0 from "./ItemTest.vue?vue&type=style&index=0&id=168a9a54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168a9a54",
  null
  
)

export default component.exports